import React from 'react';
import { Router, Switch, Redirect } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import history from 'createHistory';

import Home from 'pages/Home';
import PageNotFound from 'pages/PageNotFound';
import SetNewPassword from 'pages/SetNewPassword';
import StayTuned from 'pages/StayTuned';
import AllySignup from 'pages/allySignup';
import { SettingsPage } from 'pages/Settings';
import { ContactsLinkedInSync } from 'pages/contactsLinkedInSync';
import { Onboarding } from 'pages/Onboarding';
import ClaimYourProfile from 'pages/ClaimYourProfile';
import { CompanyOnboarding } from 'pages/Onboarding/companyOnboarding';
import { ContactsSharedListsSlackSubscribe } from '../pages/contactsSharedListsSlackSubscribe';
import { ContactsSharedListsUnsubscribe } from '../pages/contactsSharedListsUnsubscribe';
import SharedLists from '../pages/sharedLists';
import { SharedCompanyList } from '../pages/sharedCompanyList';
import PublicSignupForm from '../pages/publicSignupForm';
import Route from './Route';
import NetworkWrapper from './Network';
import { claimYourProfileRoutes } from './onboardingEmployersRoutes';
import { sessionRoutes } from './sessionRoutes';

const Routes = () => (
  <Router history={history}>
    <LastLocationProvider>
      <Switch>
        <Route
          path={['/onboarding/:networkSlug/ally-signup', '/networks/:networkSlug/ally-onboarding']}
          component={AllySignup}
          visibility={['all', 'onboarding']}
        />
        <Route
          path={['/onboarding/:networkSlug/linkedin/:action', '/linkedin/:action']}
          component={ContactsLinkedInSync}
          visibility={['user', 'onboarding']}
        />
        <Route
          path="/onboarding/:networkSlug/company/:employerSlug"
          component={CompanyOnboarding}
          visibility={['public', 'user']}
        />
        <Route path="/settings/" component={SettingsPage} visibility="user" />
        <Route
          path="/shared-lists/:slug/slack/subscribe"
          component={ContactsSharedListsSlackSubscribe}
          visibility={['public', 'onboarding', 'user']}
          exact
        />
        <Route
          path="/shared-lists/:slug/unsubscribe"
          component={ContactsSharedListsUnsubscribe}
          visibility={['public', 'onboarding', 'user']}
          exact
        />
        <Route path="/:networkId/shared-lists/:slug/signup" component={PublicSignupForm} visibility="all" exact />
        <Route path="/shared-lists/:slug" component={SharedLists} visibility="all" />
        <Route path="/shared-company-lists/:slug" component={SharedCompanyList} visibility="all" />
        <Route path="/new-password" component={SetNewPassword} visibility={['public', 'onboarding', 'user']} exact />
        <Redirect from="/networks/:networkSlug/members/share" to="/networks/:networkSlug/members/share/email" exact />
        <Redirect
          from="/claim-your-profile/:networkSlug/employer/:employerSlug"
          to={claimYourProfileRoutes.signUp.path}
        />
        <Redirect from="/onboarding/:networkSlug/employer/:employerSlug" to={claimYourProfileRoutes.signUp.path} />

        <Redirect exact from="/networks/:networkSlug/settings" to="/networks/:networkSlug/settings/general" />
        {Object.values(sessionRoutes).map(({ component, path, visibility }) => (
          <Route key={path} path={path} component={component} visibility={visibility} exact />
        ))}

        {Object.values(claimYourProfileRoutes).map(({ path, ...rest }) => (
          <Route
            key={path}
            path={path}
            component={ClaimYourProfile}
            visibility={['public', 'onboarding', 'user']}
            {...rest}
            exact
          />
        ))}
        <Route path="/" component={Home} visibility="user" exact />
        <Route path="/networks/:networkSlug/welcome" component={Onboarding} visibility={['user', 'onboarding']} />
        <Route
          path="/networks/:networkSlug/company/:employerSlug/welcome"
          component={Onboarding}
          visibility={['user', 'onboarding']}
        />
        <Route path="/networks/:networkSlug" component={NetworkWrapper} visibility="user" />
        <Route path="/stay-tuned" component={StayTuned} visibility={['user', 'onboarding']} />
        <Route path="*" component={PageNotFound} visibility="all" />
      </Switch>
    </LastLocationProvider>
  </Router>
);

export default Routes;
